/** Field/device text weight — local only (D-PS7). */

export const TEXT_WEIGHT_STORAGE_KEY = "galaxy.textWeight";

export const TEXT_WEIGHT_STEPS = [
  "default",
  "light",
  "medium",
  "bold",
] as const;

export type TextWeight = (typeof TEXT_WEIGHT_STEPS)[number];

export const TEXT_WEIGHT_LABEL: Record<TextWeight, string> = {
  default: "Vừa",
  light: "Hơi đậm",
  medium: "Đậm",
  bold: "Rất đậm",
};

export function isTextWeight(v: unknown): v is TextWeight {
  return (
    typeof v === "string" &&
    (TEXT_WEIGHT_STEPS as readonly string[]).includes(v)
  );
}

export function readTextWeight(): TextWeight {
  try {
    const raw = localStorage.getItem(TEXT_WEIGHT_STORAGE_KEY);
    if (isTextWeight(raw)) return raw;
  } catch {
    /* private mode */
  }
  return "default";
}

/** Apply to <html data-text-weight> — call before first paint when possible. */
export function applyTextWeight(weight: TextWeight): void {
  const root = document.documentElement;
  if (weight === "default") {
    root.removeAttribute("data-text-weight");
  } else {
    root.dataset.textWeight = weight;
  }
}

export function persistTextWeight(weight: TextWeight): void {
  try {
    localStorage.setItem(TEXT_WEIGHT_STORAGE_KEY, weight);
  } catch {
    /* ignore */
  }
  applyTextWeight(weight);
}

/** Boot: sync DOM from storage (idempotent). */
export function bootstrapTextWeight(): TextWeight {
  const weight = readTextWeight();
  applyTextWeight(weight);
  return weight;
}
